// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1__bbcf92bf934eeea5e4d7","cls2":"PaperAbstract-cls2___d17c500c1dd9e70d25b PaperAbstract-cls1__bbcf92bf934eeea5e4d7"};